export default {
  API_URL: 'https://pss-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://psssandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
